import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/logout.svg";

export const LogoutSvg = styled(svg)`
    margin-top: 5px;
`;